export default __webpack_public_path__ + "static/media/icon-email-2.12dae8bb.svg";